import React, { useContext } from 'react'

import { F0Checkbox } from '@factorialco/f0-react'

import { SummaryContext } from './SummaryContext'

export type Props = {
  id: string
  label: string
  note?: string
  hours: string
  testId?: string
  checked?: boolean
  onToggle?: (id: string) => void
  showSeparator?: boolean
  selectable?: boolean
}

const TimeBlockEntry = ({
  id,
  label,
  note,
  hours,
  testId,
  checked = false,
  onToggle,
  showSeparator,
  selectable = true,
}: Props) => {
  const { selectable: contextSelectable } = useContext(SummaryContext)
  const isSelectable = contextSelectable && selectable

  return (
    <>
      <div className="flex justify-between items-center px-3 py-2.5" data-testid={testId}>
        {isSelectable ? (
          <F0Checkbox checked={checked} onCheckedChange={() => onToggle?.(id)} title={label} />
        ) : (
          <span className="text-base font-normal">{label}</span>
        )}

        <div className="flex items-center gap-3">
          {note && <span className="text-base text-f1-foreground-secondary">{note}</span>}
          <span className="w-18 text-base text-right font-semibold text-gray-800">{hours}</span>
        </div>
      </div>
      {showSeparator && <div className="h-[1px] w-full bg-f1-border-secondary" />}
    </>
  )
}

export default TimeBlockEntry
